import * as Sentry from '@sentry/react';

export interface SentryInitOptions {
  dsn: string;
  environment: string;
  targets: string[];
  releaseVersion: string;
  tracesSampleRate?: number;
  profilesSampleRate?: number;
  debug?: boolean;
}

export function initializeSentry({
  dsn,
  environment,
  targets,
  tracesSampleRate = 0.02,
  profilesSampleRate = 0.02,
  releaseVersion,
  debug = false,
}: SentryInitOptions) {
  Sentry.init({
    dsn,
    environment,
    debug,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 600]],
        failedRequestTargets: targets,
      }),
    ],
    tracesSampleRate,
    tracePropagationTargets: targets,
    release: releaseVersion,
    profilesSampleRate,
  });
}
